import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import apiClient from "../Config/apiConfig";
import { toast } from "react-toastify";
import { TailSpin } from "react-loader-spinner";
import { VisibleError } from "../Components";

const Career = () => {
  const [loader, setLoader] = useState(false);
  const [careersData, setCareersData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    messages: "",
    attachment: "",
  });
  const [error, setError] = useState({
    fullNameError: false,
    emailError: false,
    phoneNumberError: false,
    messagesError: false,
    attachmentError: false,
  });
  const { fullName, email, phoneNumber, messages, attachment } = careersData;
  const {
    fullNameError,
    emailError,
    phoneNumberError,
    messagesError,
    attachmentError,
  } = error;
  const handleChange = (e) => {
    if (e?.target?.name) {
      setCareersData((data) => {
        return {
          ...data,
          [e.target.name]: e.target.value,
        };
      });
    } else {
      setCareersData((data) => {
        return {
          ...data,
          attachment: e.target.files[0],
        };
      });
    }
  };
  const careerFromSubmit = async (e) => {
    e.preventDefault();
    let check = false;
    if (fullName.trim() === "") {
      setError((old) => {
        return {
          ...old,
          fullNameError: true,
        };
      });
      check = true;
    }
    if (email.trim() === "") {
      setError((old) => {
        return {
          ...old,
          emailError: true,
        };
      });
      check = true;
    }
    if (phoneNumber.trim() === "") {
      setError((old) => {
        return {
          ...old,
          phoneNumberError: true,
        };
      });
      check = true;
    }
    if (messages.trim() === "") {
      setError((old) => {
        return {
          ...old,
          messagesError: true,
        };
      });
      check = true;
    }
    // if (attachment.trim() === "") {
    //   setError((old) => {
    //     return {
    //       ...old,
    //       attachmentError: true,
    //     };
    //   });
    //   check = true;
    // }
    if (check) {
      return;
    }
    try {
      setLoader(true);
      const res = await apiClient.upload(`api/createCareers`, {
        fullName,
        email,
        phoneNumber,
        messages,
        attachment,
      });
      console.log(res);
      if (res.data.status === "200") {
        toast.success(res.data.success);
        setCareersData({
          fullName: "",
          email: "",
          phoneNumber: "",
          messages: "",
          attachment: "",
        });
      } else if (res.data.status === "405") {
        toast.warning(res.data.error);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <div className="title-bar-wrapper">
        <Container>
          <Row>
            <div className="title">
              <h1>Career</h1>
            </div>
            <ul className="bread-crumb pull-right">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>-</li>
              <li>Career</li>
            </ul>
          </Row>
        </Container>
      </div>
      <div className="career-bg">
        <Container>
          {/* <Row>
            <div className="zeeshan-title">
              <div className="pbmit-heading-subheading center-align text-center">
                <h4 className="pbmit-subtitle">career</h4>
                <h2 className="pbmit-title">Openings Available</h2>
              </div>
            </div>
          </Row> */}
          {/* <div className="job-list">
            <Row>
              <Col md="6" className="align-self-center">
                <div className="title">
                  <h5>Lorem ipsum dolor sit amet consectetur</h5>
                  <Link>
                    <MdLocationPin />
                    31 Dr. Ambedkar Sarani, Kolkata, West Bengal 700046
                  </Link>
                </div>
              </Col>
              <Col md="6" className="align-self-center">
                <Row>
                  <Col sm="7" className="align-self-center">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="job-type">Full Time</div>
                      <div className="emp-number">
                        <FaUserTie />
                        <p className="mb-0">2</p>
                      </div>
                    </div>
                  </Col>
                  <Col sm="5" className="align-self-center">
                    <div className="more-details">
                      <Link>More Details</Link>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div> */}
          {/* <div className="job-list">
            <Row>
              <Col md="6" className="align-self-center">
                <div className="title">
                  <h5>Lorem ipsum dolor sit amet consectetur</h5>
                  <Link>
                    <MdLocationPin />
                    31 Dr. Ambedkar Sarani, Kolkata, West Bengal 700046
                  </Link>
                </div>
              </Col>
              <Col md="6" className="align-self-center">
                <Row>
                  <Col sm="7" className="align-self-center">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="job-type">Full Time</div>
                      <div className="emp-number">
                        <FaUserTie />
                        <p className="mb-0">2</p>
                      </div>
                    </div>
                  </Col>
                  <Col sm="5" className="align-self-center">
                    <div className="more-details">
                      <Link>More Details</Link>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div> */}
        </Container>
        <Container className="mt-5">
          <Row>
            <div className="zeeshan-title">
              <div className="pbmit-heading-subheading center-align text-center">
                <h2 className="pbmit-title">Drop Your CV</h2>
                <div className="pbmit-heading-desc">
                  If there aren't any openings matching your profile, you can
                  just send your resume. We will get in touch with you, if any
                  new job opportunities comes up for your profile.
                </div>
              </div>
            </div>
          </Row>
          <Row>
            <Col sm="12">
              <div className="form-inner">
              <Row className="mb-3 g-3">
                  <Col lg="6" md="6">
                    <label className="mb-2">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Full Name"
                      name="fullName"
                      onChange={(e) => {
                        handleChange(e);
                        setError((old) => {
                          return {
                            ...old,
                            fullNameError: false,
                          };
                        });
                      }}
                    />
                    <VisibleError show={fullNameError} name="Full Name" />
                  </Col>
                  <Col lg="6" md="6">
                    <label className="mb-2">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter Your Email"
                      name="email"
                      onChange={(e) => {
                        handleChange(e);
                        setError((old) => {
                          return {
                            ...old,
                            emailError: false,
                          };
                        });
                      }}
                    />
                    <VisibleError show={emailError} name="Email" />
                  </Col>
                  <Col lg="6" md="6">
                    <label className="mb-2">Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Phone Number"
                      name="phoneNumber"
                      onChange={(e) => {
                        handleChange(e);
                        setError((old) => {
                          return {
                            ...old,
                            phoneNumberError: false,
                          };
                        });
                      }}
                    />
                    <VisibleError show={phoneNumberError} name="Phone Number" />
                  </Col>
                  <Col lg="6" md="6">
                    <label className="mb-2">Messages (About your self)</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Messages"
                      name="messages"
                      onChange={(e) => {
                        handleChange(e);
                        setError((old) => {
                          return {
                            ...old,
                            messagesError: false,
                          };
                        });
                      }}
                    />
                    <VisibleError show={messagesError} name="Designation" />
                  </Col>
                  <Col lg="6" md="6">
                    <label className="mb-2">Upload Your CV</label>
                    <input
                      type="file"
                      accept=".pdf,.docx"
                      className="form-control"
                      // name="attachment"
                      onChange={(e) => {
                        handleChange(e);
                        setError((old) => {
                          return {
                            ...old,
                            attachmentError: false,
                          };
                        });
                      }}
                    />
                    <VisibleError show={attachmentError} name="CV" />
                  </Col>
                  <Col lg="12">
                    <div className="header-button mt-1">
                      <Link disabled={loader} onClick={careerFromSubmit}>
                        {loader ? (
                          <div className="d-flex justify-content-center">
                            <TailSpin height="25" width="25" color="#fff" />
                          </div>
                        ) : (
                          <>
                            submit <HiOutlineArrowNarrowRight />
                          </>
                        )}
                      </Link>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Career;
